import React from 'react';
import { Link } from "react-router-dom";
import '../assets/css/careers.css';
import {Table} from 'reactstrap';

export default class CreditRating extends React.Component {
    render() {
        return (
            <div>
                {/* <div className='career-cont'>
                    <header className="preheader">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-9">
                                    <div className="card values">
                                        <div className="row">
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Group</h4>
                                                    <p>FSDH Holding Company Limited is a non-operating holding company focused on the provision of progressive financial services in Nigeria. Our robust portfolio of subsidiaries have enabled us offer a diversified range of financial products and services across the country. Looking ahead, we aim to deepen our current business lines and expand our offerings, to maintain status as the one-stop-shop for dependable and innovative financial services in the region.</p>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Leadership</h4>
                                                    <p>FSDH Merchant Bank is an organisation that places a strong emphasis on its people. The employees are encouraged to be innovative while being client focused and to take extreme ownership while dealing with the business.  FSDH Merchant Bank has a strong team of financial experts that provide we are on hand advice to help inform your financial choices, while ensuring the final decision is always yours.</p>
                                                    <Link to="/people" className="gray-bordered-button-sm">Read more</Link>
                                                </div>
                                            </div>
                                            <div className="col-sm-4 col-md-4 val">
                                                <div className="info">
                                                    <h4 className="bold deep-blue-text">Our Story</h4>
                                                    <p>First Securities Discount House Limited, the precursor to FSDH Merchant Bank Limited, was incorporated in June 1992 as the first discount house to operate in Nigeria. In the new era, FSDH Merchant Bank Limited was one of the first merchant banks to be granted a licence to operate in Nigeria as a merchant bank.
                                                    </p>
                                                    <Link to="/about" className="gray-bordered-button-sm">Read more</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-md-3">
                                    <div className="card full-card service-card burgundy-bg">
                                        <div className="column white-text">
                                            <span>CAREERS</span>
                                            <div className="card-body">
                                                <p className="block-heading">Join the winning team</p>

                                                <Link to="/careers" className="white-button-sm">Apply</Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </header>
                </div> */}
                <div className="about">
                    <div className="body white-text"  style={{background: 'var(--fsdh-deep-blue)'}}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-sm-8">
                                    <h2 className="bold">Credit Rating</h2>
                                    <p></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="body">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-md-7 col-xl-7">
                                    {/* <h2 className="bold">Credit Rating</h2> */}
                                    <div className="card black-text">
                                        {/* <p className="bold">CREDIT RATING</p>
                                        <hr />
                                        <br /> */}
                                        <Table hover size="sm">
                                            <tbody style={{  fontSize: 12}}>
                                                    <tr className="d-flex">
                                                        <td className="col-5">Credit Rating Assigned</td>
                                                        <td className="col-7 text-uppercase">A</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Outlook</td>
                                                        <td className="col-7 text-uppercase">Stable</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Issue Date</td>
                                                        <td className="col-7 text-uppercase">3 July 2019</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Expiry Date</td>
                                                        <td className="col-7 text-uppercase">30 June 2020</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Previous Rating</td>
                                                        <td className="col-7 text-uppercase">A-</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Industry</td>
                                                        <td className="col-7 text-uppercase">Banking</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Rating Agency</td>
                                                        <td className="col-7 text-uppercase">Agusto &amp; Co. Limited, Nigeria</td>
                                                    </tr>                 
                                            </tbody>
                                        </Table>
                                    </div><br />
                                    <p>
                                    The rating assigned to FSDH Merchant Bank Limited (‘FSDH’ or ‘the Bank’) is underpinned by good capitalization, good liquidity, good profitability and an experienced management team.  FSDH’s profitability was considerably strengthened because of lower funding cost, an improvement in asset quality and moderated operating expenses despite inflationary pressures. Profit before taxation increased by 34.4% to N5.2billion, the highest in the bank’s history. The rating is however constrained by the fragile state of the Nigerian economy.
                                    </p>
                                    {/* <br /> */}
                                    <div className="card black-text">
                                        <Table hover size="sm">
                                            <tbody style={{  fontSize: 12}}>
                                                    <tr className="d-flex">
                                                        <td className="col-5">Credit Rating Assigned</td>
                                                        <td className="col-7 text-uppercase">A-</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Outlook</td>
                                                        <td className="col-7 text-uppercase">Stable</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Issue Date</td>
                                                        <td className="col-7 text-uppercase">September 2019</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Expiry Date</td>
                                                        <td className="col-7 text-uppercase">September 2020</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Previous Rating</td>
                                                        <td className="col-7 text-uppercase">A-</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Industry</td>
                                                        <td className="col-7 text-uppercase">Banking</td>
                                                    </tr><tr className="d-flex">
                                                        <td className="col-5">Rating Agency</td>
                                                        <td className="col-7 text-uppercase">GCR</td>
                                                    </tr>                 
                                            </tbody>
                                        </Table>
                                    </div>
                                    <br />
                                    <p>
                                    The rating accorded FSDH Merchant Bank Limited’s (“FSDH” or “the bank”) takes into consideration the bank’s position as flagship member FSDH Holdings Company Limited. It also considers the bank’s sustained capitalization and liquidity metrics over the period.
                                    </p>
                                   
                                </div>
                                <div className='d-sm-none d-md-block col-md-5 col-xl-5'>
                                
                                </div>
                                
                            </div>
                        </div>
                    </div>
                    <div className="subsidiaries">
                        <div className="container-fluid">
                            <p className="bold big-para-text">Affiliates</p><br />
                            <div className="row">
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">FSDH Asset Management</p>
                                    <p>
                                        FSDH Asset Management Limited (FSDH AM) was established
                                        to provide investment advisory and portfolio management
                                        services to clients whose investment horizon.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">FSDH Securities Limited</p>
                                    <p>
                                        FSDH Securities Limited (FSDH SEC) is a wholly owned
                                        subsidiary of FSDH Asset Management Limited which is
                                        also a subsidiary of FSDH Merchant Bank Limited.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                                <div className="col-md-3 col-sm-4">
                                    <p className="bold">Pensions Alliance Limited</p>
                                    <p>
                                        Pensions Alliance Limited is a joint venture between FSDH
                                        Merchant Bank Limited (FSDH MB) and African Alliance Insurance Company Limited.
                                    </p>
                                    <Link to=''>
                                        <span className="dark-blue-text">Visit Site</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}